module.exports = __webpack_public_path__ + "img/tci-logo-min.c787eab7.jpg";